
function createCustomOverlay(map, marker, content, element) {
  const overlay = document.createElement("div");
  overlay.className = "custom-map-overlay";
  overlay.style.position = "absolute";
  overlay.classList.add("bg-white", "border", "shadow-sm", "rounded-xl", "max-w-xs");
  overlay.innerHTML = content.innerHTML;
  overlay.style.display = "none";
// add a close x button to the top right corner of the overlay
  const closeButton = document.createElement("button");
  closeButton.innerHTML = "&times;";
  closeButton.style.top = "-15px";
  closeButton.style.right = "-10px";
  closeButton.classList.add("bg-white", "absolute", "border", "cursor-pointer", "text-xl", "shadow-sm", "rounded-full", "w-6", "h-6", "flex", "items-center", "justify-center", "p-0");
  overlay.appendChild(closeButton);
  element.style.position = "relative";
  element.appendChild(overlay);

  marker.addListener("click", () => {
    // Use the map's projection to get pixel coordinates for the marker
    const scale = Math.pow(2, map.getZoom());
    const proj = map.getProjection();
    const bounds = map.getBounds();
    const position = marker.position;


    if (proj && bounds) {
      const nw = proj.fromLatLngToPoint(bounds.getNorthEast());
      const se = proj.fromLatLngToPoint(bounds.getSouthWest());
      const worldPoint = proj.fromLatLngToPoint(position);

      // Calculate pixel position relative to the map container
      const x = (worldPoint.x - se.x) * scale;
      const y = (worldPoint.y - nw.y) * scale;

      // Force overlay to render off-screen to measure its dimensions
      overlay.style.visibility = "hidden";
      overlay.style.display = "block";
      overlay.style.left = "-9999px";
      overlay.style.top = "-9999px";
      element.appendChild(overlay);

      const overlayWidth = overlay.offsetWidth || 0;
      const overlayHeight = overlay.offsetHeight || 0;

      // Reset overlay styles for actual positioning
      overlay.style.visibility = "";
      overlay.style.display = "none";
      overlay.style.left = "";
      overlay.style.top = "";

      const isMobile = window.innerWidth <= 640;

      // Get the map container's position relative to the viewport
      const rect = element.getBoundingClientRect();

      if (isMobile) {
        // Bottom center on mobile, relative to the map container
        overlay.style.left = `${(rect.width - overlayWidth) / 2}px`;
        let top = y;
        if (top > overlayHeight + 20) {
          top = y - overlayHeight - 60;
        }
        overlay.style.top = `${top + 20}px`;
      } else {
        // Desktop: right of marker, vertically centered, relative to the map container
        const markerOffsetX = 20; // horizontal gap from marker
        const markerOffsetY = -overlayHeight / 2; // vertically center

        let left = x + markerOffsetX;
        let top = y + markerOffsetY;

        // If overlay goes out of right map bounds, open to the left of marker
        if (left + overlayWidth > rect.width) {
          left = x - overlayWidth - markerOffsetX;
        }

        if (top + markerOffsetY > 0) {
          top = -markerOffsetY;
        }
        if (top < 0) {
          top = 20;
        }

        overlay.style.left = `${left}px`;
        overlay.style.top = `${top}px`;
      }
    }

    // Hide all the other overlays
    document.querySelectorAll(".custom-map-overlay").forEach((ov) => {
      ov.style.display = "none";
    });

    // Show this overlay
    overlay.style.display = "block";
  });

  // Close overlay when clicking the close button
  closeButton.addEventListener("click", (e) => {
    e.stopPropagation();
    overlay.style.display = "none";
  });

  //Hide overlay when clicking elsewhere
  map.addListener("click", () => {
    overlay.style.display = "none";
  });

  // Hide overlay on window resize to avoid misplacement
  window.addEventListener("resize", () => {
    overlay.style.display = "none";
  });

  // Clean up overlay when the map element is removed from the DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.removedNodes.forEach((removedNode) => {
        if (removedNode === element) {
          overlay.remove();
          observer.disconnect();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

export { createCustomOverlay };